import { render, staticRenderFns } from "./DialogTermCodition.vue?vue&type=template&id=19a48a36&scoped=true&"
import script from "./DialogTermCodition.vue?vue&type=script&lang=js&"
export * from "./DialogTermCodition.vue?vue&type=script&lang=js&"
import style0 from "./DialogTermCodition.vue?vue&type=style&index=0&id=19a48a36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a48a36",
  null
  
)

export default component.exports